import React from "react";
import Helmet from "react-helmet";
import { truncate } from "../helpers/constants";
import { generateArticleLink } from "../helpers/linkGenerators";
import { safeJsonLdReplacer } from "../helpers/safeJsonLdReplace";
/**
 * Generate Meta/ OG Tags for Article
 * @param articleData
 * @returns {{metadata: [*], title: string}}
 */
export const getMetadataForArticleHelmet = (articleData) => {
    let summary = articleData.get("summary");
    // strip all html tags out
    summary = summary.replace(/<\/?[^>]+(>|$)/g, "");
    summary = truncate(summary, 160, "...");
    const keywords = `${articleData.get("title")},${articleData.getIn(["category_id", "name"])}`;
    const articleTitle = articleData.get("title");
    const title = articleData.get("seo_title") || articleTitle;
    const description = articleData.get("seo_description") || summary;
    return {
        metadata: [
            { name: "description", content: description },
            { name: "keywords", content: keywords },
            { property: "og:title", content: articleData.get("title") },
            { property: "og:description", content: description },
            { property: "og:image", content: articleData.get("headerImage") },
            { property: "og:image:width", content: "600" },
            { property: "og:image:height", content: "600" },
            { property: "twitter:card", content: "summary_large_image" },
            { property: "twitter:site", content: "@paytminsider" },
            { property: "twitter:title", content: articleData.get("title") },
            { property: "twitter:description", content: description },
            { property: "twitter:image", content: articleData.get("headerImage") }
        ],
        title
    };
};
/**
 * Generate Schema.org data for Article
 * @param articleData
 * @returns {*[]}
 */
export const getSchemaForArticleHelmet = (articleData) => ({
    "@context": "http://schema.org",
    "@type": "Article",
    name: `${articleData.get("title")}`,
    url: `https://insider.in${generateArticleLink(articleData.get("slug"))}`,
    mainEntityOfPage: `https://insider.in${generateArticleLink(articleData.get("slug"))}`,
    image: {
        "@type": "ImageObject",
        url: `${articleData.get("headerImage")}`,
        width: 1316,
        height: 720
    },
    author: "insider.in",
    datePublished: `${articleData.get("publish_date")}`,
    dateModified: `${articleData.get("timestamp_modified")}`,
    headline: `${articleData.get("title")}`,
    publisher: {
        "@type": "Organization",
        name: "insider.in",
        logo: {
            "@type": "ImageObject",
            url: "https://media.insider.in/image/upload/c_crop,g_custom/v1502456222/l2m5h8qmqh8079k3r0s9.png",
            height: 60,
            width: 314
        }
    }
});
const ArticleHelmet = (props) => {
    const { title, metadata } = getMetadataForArticleHelmet(props.articleData);
    const canonicalLink = `https://insider.in/${props.articleData.get("slug")}/article`;
    return (<Helmet>
			<title>{title}</title>
			<link rel="canonical" href={canonicalLink}/>
			{metadata.map((tag, i) => {
            return <meta {...tag} key={i}/>;
        })}
			<script type="application/ld+json">
				{JSON.stringify(getSchemaForArticleHelmet(props.articleData), safeJsonLdReplacer, 4)}
			</script>
		</Helmet>);
};
export default ArticleHelmet;
